import { useCallback } from "react";
import { useColorThemer } from "src/components/patterns/Background";
import {
  InputClause,
  isColumnFormulaClause,
  isCompareWithInputClause,
  isDateRangeInputClause,
  isFilterConditionInputClause,
  isFormulaInputClause,
  isGroupByClause,
  isHavingInputClause,
  isMeasureByClause,
  isSearchInputClause,
  isSelectInputClause,
} from "./definitions";

export function useClauseColor(clause?: InputClause) {
  const themer = useColorThemer();
  const toColor = useCallback(
    (clause: InputClause) => {
      if (isCompareWithInputClause(clause)) {
        return themer("blue");
      } else if (isColumnFormulaClause(clause)) {
        return themer("red");
      } else if (isDateRangeInputClause(clause)) {
        return themer("green");
      } else if (isFilterConditionInputClause(clause)) {
        return themer("yellow");
      } else if (isFormulaInputClause(clause)) {
        return themer("purple");
      } else if (isHavingInputClause(clause)) {
        return themer("orange");
      } else if (isGroupByClause(clause)) {
        return themer("magenta");
      } else if (isMeasureByClause(clause)) {
        return themer("volcano");
      } else if (isSearchInputClause(clause)) {
        return themer("cyan");
      } else if (isSelectInputClause(clause)) {
        return themer("geekblue");
      }
      return "transparent";
    },
    [themer]
  );
  if (clause) {
    return toColor(clause);
  }
  return toColor;
}
